export default "__VITE_ASSET__BINH_Ktg__"